import * as React from 'react'
import { ParentSize } from '@vx/responsive'
import InfoCard from 'components/Cards/InfoCard'
import { flow, groupBy, keyBy, map, uniq, countBy, identity, values } from 'lodash/fp'
import { GraphStackedAreas } from 'features/CallAnalytics/GraphStackedAreas'
import { moment } from 'features/Moment'
import { unitOfTime } from 'moment'
import { merge } from 'lodash'
import { ICall, IPeriodUnit } from '../../types'
import { Link } from 'react-router'
import { createKeyObject } from '../../utils'
import { mapWithKey } from '../../../../utils/lodash'

const getKeys = flow<{}[], any, string[]>(map('number'), uniq)

const formatData = (data: ICall[], sumPeriod: unitOfTime.StartOf) =>
  flow(
    map((call: ICall) => ({
      ...call,
      dateTime: moment(call.dateTime)
        .local()
        .startOf(sumPeriod)
        .format(),
    })),
    groupBy('dateTime'),
    mapWithKey((items: ICall[]) => ({
      date: items[0].dateTime,
      ...flow<ICall[], any, any>(map('number'), countBy(identity))(items),
    })),
    keyBy('date')
  )(data)

const formatBaseData = (data, keys) =>
  flow(
    map(date => ({ date, ...createKeyObject(keys) })),
    keyBy('date')
  )(data)

export interface ICallsVolumeAllServicesProps {
  calls: ICall[]
  dateInterval: string[]
  sumPeriod: IPeriodUnit
  dateFormat: string
  loading: boolean
  height?: number
  className?: string
  to?: string
  toText?: string
}

export const CallsVolumeAllServices = ({
  calls,
  dateInterval,
  sumPeriod,
  dateFormat,
  loading,
  height = 400,
  className,
  to,
  toText,
}: ICallsVolumeAllServicesProps) => {
  const keys = getKeys(calls)
  const baseData = formatBaseData(dateInterval, keys)
  const rawData = formatData(calls, sumPeriod)
  const data = values(merge(baseData, rawData))

  return (
    <InfoCard
      style={{ height: '100%' }}
      title="Call volume (last 28 days)"
      loading={loading && calls.length === 0}
      className={className}
      titleRight={<Link to="/dashboard/analytics">View analytics</Link>}
      allowOverflow
    >
      <ParentSize>
        {({ width }) => (
          <GraphStackedAreas
            width={width}
            height={height}
            data={data}
            keys={keys}
            label="Number"
            dateFormat={dateFormat}
          />
        )}
      </ParentSize>
    </InfoCard>
  )
}



// WEBPACK FOOTER //
// src/features/CallAnalytics/Cards/CallsVolumeAllServices/CallsVolumeAllServices.tsx